import { BASE_URL } from "@/utils";
import { AxiosRequestConfig } from "axios";
import getToken from "@/utils/getToken";
import getAxiosObj from "@/utils/request";

export const postPinTrenchMessage = async (
  messageId: number,
  channelId: number
) => {
  const url = `${BASE_URL}/bro/SetPinnedMessageInChat`;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    maxBodyLength: Infinity,
    method: "POST",
    data: {
      messageId,
      channelId,
    },
    url,
  };

  const axiosObj = getAxiosObj();

  const response = await axiosObj(config);
  return response;
};
